module.exports = __webpack_public_path__ + "static/media/Desktop_HomeSearchApp.bed97e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/haf/Desktop_HomeSearchApp.png
// module id = 81
// module chunks = 0